if (!customElements.get('sticky-atc-bar')) {
  customElements.define(
    'sticky-atc-bar',
    class StickyAtcBar extends HTMLElement {
      connectedCallback() {
        if (this.parentElement && this.parentElement !== document.body) {
          document.body.appendChild(this);
          return;
        }

        this.productSection = document.querySelector('.cx-product') || document.querySelector('[id^="MainProduct"]');
        if (!this.productSection) return;

        this.variantInput = this.querySelector('input[name="id"]');
        this.priceEl = this.querySelector('[data-sticky-price]');
        this.submitBtn = this.querySelector('button[type="submit"]');
        this.submitText = this.submitBtn?.querySelector('span');
        this.selects = this.querySelectorAll('[data-sticky-option-index]');
        this.variants = [];

        try {
          this.variants = JSON.parse(this.dataset.variants || '[]');
        } catch {
          this.variants = [];
        }

        this.observer = new IntersectionObserver(
          ([entry]) => this.classList.toggle('is-visible', !entry.isIntersecting),
          { threshold: 0 }
        );
        this.observer.observe(this.productSection);

        if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, this.onMainVariantChange.bind(this));
        }

        this.selects.forEach((select) => {
          select.addEventListener('change', () => {
            this.lastSelect = select;
            this.onStickySelectChange();
          });
        });
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.unsubscribe) this.unsubscribe();
      }

      onMainVariantChange({ data }) {
        const variant = data?.variant;
        if (!variant) return;

        if (this.variantInput) this.variantInput.value = variant.id;

        if (this.priceEl && variant.price != null && window.Shopify && typeof Shopify.formatMoney === 'function') {
          this.priceEl.textContent = Shopify.formatMoney(variant.price, window.shopMoneyFormat || '${{amount}}');
        }

        if (variant.options) {
          this.selects.forEach((select, i) => {
            if (variant.options[i] != null) select.value = variant.options[i];
          });
        }

        this.updateButton(variant.available);
      }

      onStickySelectChange() {
        const selectedOptions = Array.from(this.selects).map((s) => s.value);
        const variant = this.variants.find((v) =>
          v.options.every((opt, i) => opt === selectedOptions[i])
        );

        if (variant) {
          if (this.variantInput) this.variantInput.value = variant.id;

          if (this.priceEl && window.Shopify && typeof Shopify.formatMoney === 'function') {
            this.priceEl.textContent = Shopify.formatMoney(variant.price, window.shopMoneyFormat || '${{amount}}');
          }

          this.updateButton(variant.available);
          this.syncToMainPicker(selectedOptions);
        } else {
          this.updateButton(false);
        }
      }

      holdScroll(ms) {
        const bar = this;
        bar.scrollHoldY = window.scrollY;
        bar.scrollHoldUntil = Date.now() + ms;
        if (bar.scrollHoldActive) return;
        bar.scrollHoldActive = true;

        const original = window.scrollTo;
        const html = document.documentElement;
        const restore = () => {
          if (Math.abs(window.scrollY - bar.scrollHoldY) < 2) return;
          const prev = html.style.scrollBehavior;
          html.style.scrollBehavior = 'auto';
          (document.scrollingElement || html).scrollTop = bar.scrollHoldY;
          html.style.scrollBehavior = prev;
        };
        const onFocus = (event) => {
          if (Date.now() > bar.scrollHoldUntil) return;
          if (!event.target.closest || !event.target.closest('variant-selects')) return;
          restore();
          requestAnimationFrame(restore);
          setTimeout(restore, 80);
          if (bar.lastSelect) bar.lastSelect.focus({ preventScroll: true });
          bar.scrollHoldUntil = Math.min(bar.scrollHoldUntil, Date.now() + 400);
        };

        window.scrollTo = function () {
          if (Date.now() < bar.scrollHoldUntil) return;
          return original.apply(window, arguments);
        };
        document.addEventListener('focusin', onFocus, true);

        const release = () => {
          if (Date.now() < bar.scrollHoldUntil) {
            setTimeout(release, bar.scrollHoldUntil - Date.now() + 20);
            return;
          }
          window.scrollTo = original;
          document.removeEventListener('focusin', onFocus, true);
          bar.scrollHoldActive = false;
        };
        setTimeout(release, ms + 20);
      }

      syncToMainPicker(selectedOptions) {
        const mainSelects = this.productSection.querySelector('variant-selects');
        if (!mainSelects) return;

        this.holdScroll(5000);

        const fieldsets = mainSelects.querySelectorAll('fieldset');
        if (fieldsets.length > 0) {
          fieldsets.forEach((fieldset, i) => {
            if (selectedOptions[i] == null) return;
            const radio = fieldset.querySelector(`input[value="${CSS.escape(selectedOptions[i])}"]`);
            if (radio && !radio.checked) {
              radio.checked = true;
              radio.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
          return;
        }

        const dropdownSelects = mainSelects.querySelectorAll('select');
        dropdownSelects.forEach((select, i) => {
          if (selectedOptions[i] != null && select.value !== selectedOptions[i]) {
            select.value = selectedOptions[i];
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      }

      updateButton(available) {
        if (!this.submitBtn) return;
        if (available) {
          this.submitBtn.removeAttribute('disabled');
          if (this.submitText) this.submitText.textContent = window.variantStrings?.addToCart || 'Add to cart';
        } else {
          this.submitBtn.setAttribute('disabled', 'disabled');
          if (this.submitText) this.submitText.textContent = window.variantStrings?.soldOut || 'Sold out';
        }
      }
    }
  );
}
